import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dropcontact = defineConnector({
  identifier: "dropcontact",
  name: "Dropcontact",
  tagLine: "Email enrichment",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.dropcontact\\.io/.*",
  auth: (app) =>
    headerAuth([{ name: "X-Access-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Dropcontact](https://app.dropcontact.io/), go to **API** in the sidebar to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.dropcontact.io/batch",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: [{ email: "" }] }),
    }),
  },
});
